import { Browser } from '@capacitor/browser';

export const openExternalMenuLink = (url: string): Promise<void> => Browser.open({ url });
